"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const planGroup_1 = __importDefault(require("./planGroup"));
class Formatter {
    getCurrentPlanGroupData() {
        if (typeof amplitudePlanGroup === "undefined") {
            return null;
        }
        return new planGroup_1.default(amplitudePlanGroup);
    }
}
exports.default = Formatter;
